export default "__VITE_ASSET__jFHKLr$U__"